exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.disabled[data-v-bfcd6eee] {\n  background-color: #ffffff;\n}\n", ""]);

